import { HomeTodayMatch, iHome } from '../helpers/interfaces/home';
import { ICategory } from '../helpers/interfaces/ranking';
import { VideosList } from '../helpers/interfaces/video';
import { apiGet } from "./Api";

export const homeService = {
    getHome: async() => await apiGet<iHome, undefined>('?op=home'),
    getMenuCategories: async() => await apiGet<ICategory[], undefined>(('?op=menuCategorie')),
    getVideosList: async() => await apiGet<VideosList, undefined>('?op=listaVideo'),
    getTodayMatchs: async(date: string) => await apiGet<HomeTodayMatch[], undefined>('?op=partitePerGiorno&giorno=' + date + '&sezione=home'),
}